<template>
  <main id="app" class="" :data-time="time">
<!--    <div class="ADMIN">-->
<!--    ADMIN TOOL - SKIP TO SECTION : -->
<!--      <span @input="forceActive" contenteditable class="bg-white py-2 px-8 inline-block">-->
<!--        {{active}}-->
<!--      </span>-->
<!--    </div>-->
    <!-- //! =============== INTRO =============== -->
    <section 
      class="intro" 
      :class="active === 0 ? 'active' : 'hide'"
    > 
      <div class="intro-header-cont">
        <div class="intro-header">
          <div class="intro-title">
            <h1 class="subhead">{{intro.title}}</h1>
            <h2 class="headline">{{intro.headline}} </h2>
          </div>
        </div>
      </div>
      <div class="intro-content">
        <div class="content">
          <h3 class="pb-4 lg:pb-6">{{intro.contentTitle}} </h3>
          <p>{{intro.content}}</p>
        </div>
        <div class="imported-form">
          <p class="imported-form__title pb-6">{{intro.formTitle}}</p>
          <div class="imported-form__form">
            <form id="mktoForm_4310" class="mktoForm"></form>
          </div>
        </div>
      </div>
    </section>
    <!-- //! =============== QUESTIONS =============== -->
    <section 
      id="questions" 
      :class="(active > 0 && active <= questions.length)  ? 'active' : 'hide'" 
      class=""
    >
      <div class="grid cont grid-cols-12">
        <div id="navbar" :data-time="time">
          <div
              v-for="(question, qi) in questions"
              :key="question.question"
              class="navbar-item"
              @click="setActive(qi + 1)"
              :class="question.status"
              :data-time="time"
          >
            <span class="text-sm">{{qi + 1}}</span>
          </div>
        </div>
        <div class="questions-body">
          <div
            v-for="(question, qi) in questions"
            :key="'q' + qi"
            :class="active === (qi + 1) ? 'active' : 'hide'"
            class="question"
          >
            <div class="question-container input-cont">
              <div class="question-text">
                <h2>{{ question.question }}</h2>
              </div>
              <div class="question-content">
                <p class="mb-2">{{question.instructions}}</p>
                <div class="flex items-center question-wrapper">
                  <div class="question-input" :class="question.type">
                    <div class="rangeoverlay-cont" v-if="question.type === 'slider'">
                      <div :style="{width: `${question.chosen < 3 ? 2.5 : question.chosen < 10 ? question.chosen * 1.08 : question.chosen > 50 ? question.chosen * .97 : question.chosen}%`}" class="rangeoverlay" v-if="question.type === 'slider'"></div>
                    </div>
                    <input
                    :ref="`q${qi}`"
                    v-model="question.chosen"
                    @input="reload(); show(qi); test(qi)"
                    @mousemove="reload()"
                    pattern="([0-9]+.{0,1}[0-9]*,{0,1})*[0-9]"
                    :type="(question.type === 'number' || question.type === 'dollars') ? 'number' : 'range'"
                    :max="(question.type !== 'number' && question.type !== 'dollars') ? '100' : '9999999'"
                    min="0"
                    placeholder="0"
                    />
                    <!-- <input v-else-if="question.type === 'slider'" type="range" v-model="question.chosen" /> -->
                  </div>
                  <span class="percent" v-if="question.type === 'slider'">{{question.chosen}}%</span>
                </div>
                <div class="error text-red-400 pt-1" v-if="question.error">
                  {{question.error}}
                </div>
                <div class="post-nav">
                  <button class="btn ltbtn" @click="setActive(active - 1)" v-if="qi > 0">
                    {{questionpages.previousbutton}}
                  </button>
                  <button
                    class="btn"
                    @click="setActive(active + 1); active === questions.length + 1 && submitForm()"
                    :class="(question.error || !question.optional && (!question.chosen || !question.chosen.length)) ? 'inactive' : ''"
                  >
                    {{qi >= questions.length - 1 ? questionpages.resultbutton : questionpages.nextbutton}}
                  </button>
                </div>
                <!-- <div class="p-8" v-else ></div> -->
              </div>
            </div>
            <aside class="question-aside rounded" aria-label="Stats Block">
              <h3>{{ question.statTitle }}</h3>
              <p>{{ question.stat }}</p>
            </aside>
          </div>
        </div>

      </div>
    </section>
    <!-- //! =================== RESULTS ======================= -->
    <section 
      id="results" 
      :class="active >= questions.length + 1 ? 'active' : 'hide'" 
      class=""
    >
      <div class="results-header-cont">
        <div class="results-header">
          <div class="result-cont">
            <div class="title-cont">
<!--              <h1 class="title">{{resultspage.title}}</h1>-->
              <h2 class="text" v-html="resultspage.headlineHTML"> </h2>
            </div>
            <p class="result">${{numberWithCommas(numberTimesX(result, 12))}}<span class="dol">USD</span></p>
          </div>
        </div>
      </div>
      <div class="results-content">
        <div class="imported-form">
          <h3 class="imported-form__title">Ready to cut customer service costs?</h3>
          <button @click="submitForm()" class="btn">{{resultspage.cta}}</button>
          <div class="pt-6">
            <span v-html="resultspage.watchvideoHTML"></span>
            <span class="pl-6"><a @click="restart()" >{{resultspage.startover}}</a></span>
          </div>
        </div>
        <div class="content">
          <p class="pb-6" v-html="resultspage.contentHTML"> </p>
        </div>
      </div>
    </section>
    
  </main>
</template>
<style lang="scss">
  @import "./styles/tailwind-utils.scss";
  @import "./styles/styles.scss";
</style>

<script>
import copy from "./copy.js";
import svg from "./robot.js";
import gsap from 'gsap';
// import MorphSVGPlugin from '@/libraries/gsap/MorphSVGPlugin';
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin.js";
// gsap.MorphSVGPlugin
console.log(gsap, MorphSVGPlugin)
gsap.registerPlugin(MorphSVGPlugin);

MorphSVGPlugin.convertToPath(
  "circle, rect, ellipse, line, polygon, polyline"
);

var tl = gsap.timeline();

var time = Date.now();
export default {
  name: 'App',
  data() { return ({
    time: time,
    active: 0,
    result: {},
    intro: copy.intro,
    questionpages: copy.questionpages,
    questions: copy.questions,
    resultspage: copy.results,
    svg
  })},
  beforeMount: function beforeMount() {
    this.reset();
  },
  methods: {
    robotAnimationSet() {
      // === Load ===============================
      tl
        .set("#left-eye-neutral", {opacity: 0})
        .set("#left-eye--bored", {opacity: 0})
        .set("#left-eye--happy", {opacity: 0})
        .set("#right-eye-neutral", {opacity: 0})
        .set("#right-eye--bored", {opacity: 0})
        .set("#right-eye--happy", {opacity: 0})
        .set("#mouth-neutral", {opacity: 0})
        .set("#mouth-bored", {opacity: 0})
        .set("#mouth-happy", {opacity: 0})
        .set("#left-eye-skeptical", {opacity: 0})
        .set("#right-eye-skeptical", {opacity: 0})
        .set("#mouth-skeptical", {opacity: 0});
    },
    robotAnimation_To_Neutral() {
      tl
        .to("#right-eyebrow-robot", {morphSVG: '#right-eyebrow-neutral', duration: .6}, "+=.2")
        .to("#right-eye--robot", {morphSVG: '#right-eye--neutral', duration: .6}, "<")
        .to("#left-eyebrow-robot", {morphSVG: '#left-eyebrow-neutral', duration: .5}, "-=.5")
        .to("#left-eye--robot", {morphSVG: '#left-eye--neutral', duration: .5}, "<")
        .to("#mouth-robot", {morphSVG: '#mouth-neutral', duration: .4}, "-=.4");
    },
    robotAnimation_To_Bored() {
      tl
        .to("#right-eyebrow-robot", {morphSVG: '#right-eye--bored', duration: .6}, "+=.8")
        .to("#right-eye--robot", {morphSVG: '#right-eye--bored', duration: .6}, "<")
        .to("#left-eyebrow-robot", {morphSVG: '#left-eye--bored', duration: .6}, "<")
        .to("#left-eye--robot", {morphSVG: '#left-eye--bored', duration: .6}, "<")
        .to("#mouth-robot", {morphSVG: '#mouth-bored', duration: .4}, "-=.4");
    },
    robotAnimation_To_Skeptical() {
      tl
        .to("#right-eyebrow-robot", {morphSVG: '#right-eyebrow-skeptical', duration: .6}, "+=.2")
        .to("#right-eye--robot", {morphSVG: '#right-eye--skeptical', duration: .6}, "<")
        .to("#left-eyebrow-robot", {morphSVG: '#left-eyebrow-skeptical', duration: .6}, "<")
        .to("#left-eye--robot", {morphSVG: '#left-eye--skeptical', duration: .6}, "<")
        .to("#mouth-robot", {morphSVG: '#mouth-skeptical', duration: .4}, "-=.4");
    },
    robotAnimation_To_Happy() {
      tl
        .to("#right-eyebrow-robot", {morphSVG: '#right-eye--happy', duration: .6}, "+=.2")
        .to("#right-eye--robot", {morphSVG: '#right-eye--happy', duration: .6}, "<")
        .to("#left-eyebrow-robot", {morphSVG: '#left-eye--happy', duration: .6}, "<")
        .to("#left-eye--robot", {morphSVG: '#left-eye--happy', duration: .6}, "<")
        .to("#mouth-robot", {morphSVG: '#mouth-happy', duration: .4}, "-=.4");
        

    },
    robotAnimation_Delay() {
      tl
        .to("#mouth-robot", {opacity: 1, duration: 0}, "+=.8");
        

    },
    reload: function() {
      this.time = Date.now();
    },
    forceActive(e) {
      let targ = parseInt(e.target.innerText);
      this.setActive(targ);
    },
    // ====== Function to select the active section (on click of the next button or a quick nav button)
    setActive: function setActive(payload) {
      // is the payload pointing to a question - and if so is that question currently unavailable?
      if (payload > 0 && payload < this.questions.length && this.questions[payload - 1].status && this.questions[payload - 1].status.includes('unavailable')) {
        // if so, either skip to that question entirely
        if (payload === this.active + 1) {
          this.active = payload + 1;
        } else {
          this.active = payload - 1;
        }
      } else {
        //if the payload is not an unavailable question
        this.active = payload;

      }
      this.reload();

      switch (this.active) {
        case 6:
          this.robotAnimation_To_Happy();
          this.robotAnimation_Delay();
          this.robotAnimation_Delay();
          this.robotAnimation_Delay();
          tl
            .to("#right-eyebrow-robot", {morphSVG: '#right-eye--neutral', duration: .2}, "+=.2")
            .to("#right-eye--robot", {morphSVG: '#right-eye--neutral', duration: .2}, "<")
            .to("#left-eyebrow-robot", {morphSVG: '#left-eye--neutral', duration: .2}, "<")
            .to("#left-eye--robot", {morphSVG: '#left-eye--neutral', duration: .2}, "<")
          this.robotAnimation_To_Happy();
          break;
        case 1:
          this.robotAnimation_Delay();
          this.robotAnimation_To_Bored();
          break;
        case 2:
          this.robotAnimation_Delay();
          this.robotAnimation_To_Neutral();
          break;
        case 3:
          this.robotAnimation_To_Skeptical();
          this.robotAnimation_Delay();
          this.robotAnimation_To_Neutral();
          break;
        case 4:
          this.robotAnimation_To_Bored();
          this.robotAnimation_To_Neutral();
          this.robotAnimation_Delay();
          this.robotAnimation_To_Skeptical();
          break;
        case 5:
          this.robotAnimation_To_Bored();
          this.robotAnimation_To_Skeptical();
          this.robotAnimation_Delay();

      }
    },
    reset() {
      this.questions.forEach(function (q) {
        if (q.type === 'slider') {
          return q.chosen = 0;
        }
        return q.chosen = '';
      });
    },
    // ====== function to restart the tool
    restart: function restart() {
      this.active = 1;
      this.reset();
    },
    // ====== function to select an answer
    setAnswer: function setAnswer(qi, choice) {
      // when an answer is selected..

      if (this.questions[qi].type === 'radio') {
        // ...if the question is a radio type - select the choice directly.
        this.questions[qi].chosen = [choice];
        if (this.questions[qi].scorechart !== undefined) {
          this.scores[qi] = this.questions[qi].scorechart[choice];
        }
      } else {
        choice = this.questions[qi].choices[choice];

        if (!this.questions[qi].chosen) {
          // ..or else if there is no answer currently chosen, create an array and select the choice.
          this.questions[qi].chosen = [choice];
        } else if (this.questions[qi].chosen.includes(choice)) {
          // ..or else if this answer was already chosen, unselect this choice.
          this.questions[qi].chosen.splice(this.questions[qi].chosen.indexOf(choice), 1);
        } else {
          // ..or else if there is an answer already, add this choice to the list of answers.
          this.questions[qi].chosen.push(choice);
        }
      }

      this.reload();
    },
    numberTimesX(number, x) {
      return number*x;
    },
    numberWithCommas(x) {
      x = x.toString();
      var pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x))
          x = x.replace(pattern, "$1,$2");
      return x;
    },
    // numberNoCommas(x) {
    //   x = x.toString();
    //   var pattern = /(-?\d+)(\d{3})/;
    //   while (pattern.test(x))
    //       x = x.replace(pattern, "$1$2");
    //   return x;
    // },
    resultCheck() {

        // function numberNoCommas(x) {
        //   x = x.toString();
        //   var pattern = /(-?\d+)(\d{3})/;
        //   while (pattern.test(x))
        //       x = x.replace(pattern, "$1$2");
        //   return x;
        // }
        // avgCallCost / ( numOfCalls * avgCallLength ) 
        var numOfCalls = this.questions[0].chosen;
        var avgCallCost = this.questions[2].chosen;
        // numOfCalls = numberNoCommas(numOfCalls);
        // avgCallCost = numberNoCommas(avgCallCost);

        const percentCallVolDrop = this.questions[3].chosen / 100;
        const percentCallLengthDrop = this.questions[4].chosen / 100;
        const callSpending = (numOfCalls * avgCallCost)
        const result = callSpending - ((numOfCalls - (numOfCalls * percentCallVolDrop)) * ((avgCallCost - (avgCallCost * percentCallLengthDrop))));

        this.result = Math.trunc(result, 2)
        this.reload();
    },
    mountForm(){
      (function() {
        var didInit = false;
        function initMunchkin() {
          if(didInit === false) {
            didInit = true;
            // eslint-disable-next-line no-undef
            Munchkin.init('579-JML-927');
          }
        }
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = '//munchkin.marketo.net/munchkin-beta.js';
        s.onreadystatechange = function() {
          if (this.readyState == 'complete' || this.readyState == 'loaded') {
            initMunchkin();
          }
        };
        s.onload = initMunchkin;
        document.getElementsByTagName('head')[0].appendChild(s);
      })();
      // eslint-disable-next-line no-undef
      MktoForms2.loadForm("//app-sjg.marketo.com", "579-JML-927", 4310);

      // For front end (can ignore)
      const forward = (() => this.setActive(1));

      // eslint-disable-next-line no-undef
      MktoForms2.whenReady(function(form) {
        console.log('ready')
        form.onSuccess(function() {
            console.log('success', form.getValues());
            forward();
            // Return false to prevent the submission handler continuing with its own processing
            return false;
        });
      });
      
    },
    submitForm() {
      const config = this.questions;
      console.log('trying submitting', config);
      // eslint-disable-next-line no-undef
      MktoForms2.getForm(4310, (form) => {
        console.log('gotform', form);
        const vals = form.vals();
        vals.questions = config;
        form.onSubmit(() => {
          form.vals(vals);
        });
        // form.onSuccess((() => {
        form.onValidate((() => {
          console.log('submitting', config);
          return false;
        }));
        form.validate();
        // form.submit();
      });
    },
    show(qi) {
      this.questions[qi].showextra = true;
    },
    test(a) {
      if (this.$refs[`q${a}`]) {
        if (this.$refs[`q${a}`][0].validationMessage === 'Please enter a number.') {
          this.questions[a].error = 'Numeric values only.'
        } else if (this.$refs[`q${a}`][0].validationMessage === 'Please select a value that is no more than 9999999.') {
          this.questions[a].error = 'Please enter a value that is no more than 9,999,999.'
        } else {

          this.questions[a].error = this.$refs[`q${a}`][0].validationMessage;
        }
      }
      console.log(this.questions[a].error, this.$refs[`q${a}`])
    }

  },
  updated() {
    // ====== whenever something happens in the tool...
    var currentActive = this.active;
    var questions = this.questions;
    // .. loop through each question...
    questions.forEach(function (q, qi, arr) {
      // ...find the questions that have been passed
      var prevQuestions = arr.filter(function (qq, qqi) {
        return qqi < qi;
      });

      // ...find how many questions have been answered
      var prevAnsweredQuestions = prevQuestions.filter(function (qq) {
        return qq.chosen.length || qq.optional;
      }).length;

      // ...check if all previous answers have been answered
      var isAvailable = prevAnsweredQuestions >= qi;

      // check if this question is conditional
      if (q.removeIf) {
        // set a temporary store of value
        var tempValue = false;
        // if it is, check each conditional trigger
        q.removeIf.forEach(function (trigger) {
          var triggerQ = questions[trigger.q].chosen;
          var triggerA = questions[trigger.q].choices[trigger.a];

          // check if this trigger question is currently active
          if (currentActive - 1 === trigger.q) {
            // if it is active - check if the trigger answer has been selected
            if (q.chosen.length) {
              // if the trigger was selected - set the temporary store to answered
              tempValue = 'answered';
            } else {
              // if the trigger was not selected - set the temporary store to answered
              tempValue = 'inactive';
            }
          } else if (triggerQ === triggerA) {
            // if the trigger answer has been selected, 
            // make this conditional question unavailable by setting the temp store to unavilable
            tempValue = 'unavailable';
          }
        });

        //if the temp store has been altered - set the question status to that value
        if (tempValue) {
          q.status = tempValue;
        }
      }

      if (currentActive === qi + 1) {
        q.status = 'active';
      } else if (q.chosen.length) {
        q.status = 'answered';
      } else if (!isAvailable) {
        q.status = 'inactive';
      } else {
        q.status = '';
      }
    });
    this.questions = questions;

    this.resultCheck();
    this.reload();
  },
  computed: {
    resultTrigger: function resultTrigger() {
      this.reload();

      var requiredQuestions = this.questions.filter(function (q) {
        return !q.optional;
      });
      var unansweredRQs = requiredQuestions.filter(function (q) {
        return q.optional === false || q.chosen && q.chosen.length < 1;
      }); 
      if (this.active === this.questions.length + 1) {
        return 'active';
      }

      if (unansweredRQs.length === 0) {
        return '';
      }

      return 'inactive';
    },
    navLength: function navLength() {
      return this.questions.filter(function (q) {
        return q.status !== 'unavailaible';
      }).length + 1;
    }, // const navLength = ref(6);
    // questionstatus: function quetionstatus() {
    //   check(val) {
        
    //   }
    //   this.questions.forEach(q => check(q.chosen));
    //   return 0;
    // }

  },
  mounted: function mounted() {
    // Object.values(this.questions).forEach(q => { 
    // });
    this.robotAnimationSet();
    this.mountForm();

  }
};
</script>
